/**
 * Whether a margin needs approval against its order's limit — the one rule every
 * margin pill, badge and cell colours by, so no two screens can disagree on a pro.
 *
 * Below the limit, not at it (SR-7685): a 30.00% margin on a 30% limit is fine. This is
 * the rule V1's buckets hold on (Invoicing Hold > Margin); V1's showmargin screen reds
 * at <= and was the outlier. Compared at the 2 decimals every screen shows, so float
 * division landing at 19.999999999999993 is not "below" a 20% limit. The backend
 * applies the same rule in margin_service (`underLimit`).
 */
export const isBelowMarginLimit = (marginPct: number, marginLimit: number): boolean =>
  Number(marginPct.toFixed(2)) < marginLimit;
